import { Link, LinkProps } from '@tanstack/react-router';
import { getButtonStyles } from '@sc/shared-ui';

export type To = NonNullable<LinkProps['to']>;

interface Props {
  to: To;
}

const NotFound = ({ to }: Props) => (
  <div className="flex items-center justify-center flex-col grow relative min-h-screen px-5">
    <div className="text-center flex flex-col items-center">
      <Link to={to} aria-label="Stark Crawl home">
        <img
          src="/lock-up.svg"
          alt="Stark Crawl"
          width="146"
          height="20"
          className="h-6 w-auto mb-10"
        />
      </Link>
      <h1 className="font-grotesque text-[4.375rem] leading-none font-medium text-white mb-5">
        404
      </h1>
      <h2 className="text-lg leading-6.5 text-grey-300 mb-8 max-w-125">
        Sorry, we can&apos;t seem to find what you&apos;re looking for.
      </h2>
      <Link
        to={to}
        {...getButtonStyles({
          type: 'primary',
          size: 'large',
          additionalClassnames: 'gap-x-2',
        })}
      >
        Go back
      </Link>
    </div>
  </div>
);

export default NotFound;
